import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { IBroadcastEmailRequest, IBroadcastEmailResponse } from '../../../assets/types/dtoTypes';

/** Client for the admin broadcast email endpoint (backend #81). */
@Injectable({ providedIn: 'root' })
export class AdminBroadcastService {
  private http = inject(HttpClient);

  private url = `${environment.apiUrl}/admin/emails`;

  sendBroadcast(request: IBroadcastEmailRequest): Observable<IBroadcastEmailResponse> {
    return this.http.post<IBroadcastEmailResponse>(`${this.url}/broadcast`, request);
  }
}
